import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from '@ptl/xhr';
import { BrandingConfigurationService } from '@ptl/brand';

@Injectable({
  providedIn: 'root'
})
export class MassEnrollmentUploadService {

  constructor(
    private httpClient: HTTPWrapperContext,
    private brandService: BrandingConfigurationService
  ) {}

  async uploadFile(file, loginId): Promise<any> {

    const payload = new FormData();
    payload.append('file', file);
    payload.append('loginId', loginId);

    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.POST,
        POST_OR_PUT_PAYLOAD: payload,
        url: '/sxesvc/api/v3/mass-enrollment/upload',
        contentType: 'force_undefined',
        headers: new HttpHeaders({
          ddToken: this.brandService.getCurrentBrand().ddToken_encoded(),
        }),
        strategyConfigs: { forceModernUrl: true }
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS);
    return this.httpClient.makeRequest(requestConfig);
  }

  async retrieveFilesByLoginId(loginId){

    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.GET,
        url: '/sxesvc/api/v3/mass-enrollment/fetchMassEnrollmentStatus' + "?loginId=" + loginId.toUpperCase(),
        strategyConfigs: { forceModernUrl: true }
    });
    
    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS);
    return this.httpClient.makeRequest(requestConfig);

  }


}
